const nlBaseUrl = 'https://www.chefsculinar.de/';

export function initnewsletter(){
    function newsletterWaiting(isWaiting){
        if(isWaiting){
            $("body").addClass("newsletter_waiting");
            var waitingLabel = $("<div class='newsletter_waiting__text'>Einen Moment bitte</div>");
            $("body").append(waitingLabel);
        }
        else{
            $("body").removeClass("newsletter_waiting");
            $(".newsletter_waiting__text").remove();
        }
    }

    var validateEmail = function (email) {
        var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
        return re.test(email);
    };


    var newRecipient = function(recEmail,recGroup1, element, transaction ){
        newsletterWaiting(true);
        $.ajax({
            url: nlBaseUrl + "newsletterasync.json",
            type: "get",
            data:{
                email: recEmail,
                action: 'getUserData',
                transactionid: typeof(transaction) !== "undefined" ? transaction : ""
            }
        }).done(function(res){
            function overrideModalHead(headnode, textattr){
                headnode.text(textattr);
            }
            function overrideModalContent(contentnode, textattr, labelattr, linkattr){
                contentnode.html('');
                if(textattr){
                    contentnode.append("<p>" + textattr +"</p>");
                }
                if(labelattr && linkattr){
                    contentnode.append("<br>");
                    let modalButton = $( "<a href class='smc__btn' target='_blank'>" + labelattr + "</a>" );
                    contentnode.prop("href", linkattr);
                    contentnode.append(modalButton);
                }

            }
            if(res["found"] === true){
                newsletterWaiting(false);
                var found = false;
                for(var x = 0 ; x < res["groups"].length ; x++){
                    if(res["groups"][x]["name"] === recGroup1){
                        if (element.hasClass("btn-nl-appendcontent")){
                            let modalcontent = $("#modal-newsletter-bereits-angemeldet").find(".modal-body");
                            if(modalcontent.children().length === 1){
                                overrideModalContent(modalcontent, element.data("signeduptext"), element.data("signeduplabel"), element.data("signedupurl"));
                                /*modalcontent.html('');
                                if(element.data("signeduptext")){
                                    modalcontent.append("<p>" + element.data("signeduptext")+"</p>");
                                }
                                if(element.data("signedupurl") && element.data("signeduplabel")){
                                    modalcontent.append("<br>");
                                    let modalButton = $( "<a href class='smc__btn'>"+element.data("signeduplabel")+"</a>" );
                                    modalButton.prop("href", element.data("signedupurl"));
                                    modalcontent.append(modalButton);
                                }*/
                            }
                        }

                        $("#modal-newsletter-bereits-angemeldet").modal("show");
                        found = true;
                        //user in NL db AND in the group that was requested
                    }

                }
                if(found === false){
                    //not in group, but in NL DB
                    $.ajax({
                        url: nlBaseUrl + "newsletterasync.json",
                        type: "get",
                        data: {
                            action: 'addToGroup',
                            email: recEmail,
                            group: recGroup1
                        }
                    });
                    $(".newsletter-tooltip").removeClass("active");
                    $("#modal-newsletter").modal("hide");
                    var label = "";
                    if(recGroup1.indexOf("GV") != -1){
                        label = "GV";
                    }
                    else{
                        label = "Gastro";
                    }
                    var boxText = $("#modal-newsletter-anmeldung-ok .second").data("text").replace("NEU", label);
                    $("#modal-newsletter-anmeldung-ok .second").html(boxText);
                    $("#modal-newsletter-anmeldung-ok .first").hide();
                    $("#modal-newsletter-anmeldung-ok .second").show();

                    if (element.hasClass("btn-nl-appendcontent")){
                        console.log('node ', $("#modal-newsletter-anmeldung-ok").find(".modal-body"));
                        let modalcontent = $("#modal-newsletter-anmeldung-ok").find(".modal-body");
                        console.log('length ', modalcontent.length);
                        overrideModalHead($("#modal-newsletter-anmeldung-ok").find(".modal-title"));
                        overrideModalContent(modalcontent, element.data("newgrouptext"), element.data("newgrouplabel"), element.data("newgroupurl"))

                        /*if(modalcontent.children().length === 1){
                            modalcontent.html('');
                            if(element.data("signeduptext")){
                                modalcontent.append("<p>" + element.data("signeduptext")+"</p>");
                            }
                            if(element.data("signedupurl") && element.data("signeduplabel")){
                                modalcontent.append("<br>");
                                let modalButton = $( "<a href class='smc__btn'>"+element.data("signeduplabel")+"</a>" );
                                modalButton.prop("href", element.data("signedupurl"));
                                modalcontent.append(modalButton);
                            }
                        }*/
                    }

                    $("#modal-newsletter-anmeldung-ok").modal("show");
                }
            }
            else{
                //not in DB, add new
                newsletterWaiting(false);
                var action = "";
                if(recGroup1 === "GV"){
                    if(element.hasClass("btn-nl-gv-special")){
                        action = "subscribeGVSpecial";
                    }
                    else{
                        action = "subscribeGV";
                    }
                }
                else if(recGroup1 === "Gastro"){
                    if(element.hasClass("btn-nl-gastro-special")){
                        action = "subscribeGastroSpecial";
                    }
                    else if(element.hasClass('btn-nl-gastro-smc')){
                        action = "subscribeSMC";
                    }
                    else{
                        action = "subscribeGastro";
                    }
                }
                else{
                    return;
                }

                var triggerAttr = element.data("trigger");
                var trigger = typeof(triggerAttr) !== "undefined" ? triggerAttr : "";
                $.ajax({
                    url: nlBaseUrl + "newsletterasync.json",
                    type: "get",
                    data: {
                        email: recEmail,
                        action: action,
                        transactionid: typeof(transaction) !== "undefined" ? transaction : "",
                        trigger: trigger
                    }
                });

                $(".newsletter-tooltip").removeClass("active");
                $("#modal-newsletter").modal("hide");
                $("#modal-newsletter-anmeldung-ok .second").hide();
                $("#modal-newsletter-anmeldung-ok .first").show();
                const modalcontent = $("#modal-newsletter-anmeldung-ok").find(".modal-body");
                if(modalcontent.children().length === 1){
                    overrideModalContent(modalcontent, element.data("newrectext"), element.data("newgrouplabel"), element.data("newgroupurl"))
                }

                $("#modal-newsletter-anmeldung-ok").modal("show");
            }
        });
    };

    var removeRecipient = function (recEmail) {
        newsletterWaiting(true);
        $.ajax({
            url: nlBaseUrl + "nl.html",
            type: "get",
            data: {
                email: recEmail,
                action: "removeRecipient"
            }
        }).done(function (res) {
            newsletterWaiting(false);
            if (res.trim() === "successfully removed") {
                $("#modal-newsletter-abmeldung").modal("hide");
                $("#modal-newsletter-abmeldung-ok").modal("show");
            } else if (res.trim() === "does not exist") {
                $("#modal-newsletter-fehler-abmeldung").modal("show");
            } else {
                $("#modal-newsletter-fehler-abmeldung").modal("show");
            }
        });
    };

    var removeFromGroup = function (recEmail, recGroup) {
        $.ajax({
            url: nlBaseUrl + "nl.html",
            type: "get",
            data: {
                email: recEmail,
                action: "removeRecipientFromGroup",
                group: recGroup
            }
        }).done(function (res) {
            if (res.trim() === "successfully removed g") {
                $("#modal-newsletter-abmeldung").modal("hide");
                $("#modal-newsletter-abmeldung-ok").modal("show");
                $(".nl-checkbox").hide();
            } else if (res.trim() === "does not exist") {
                $("#modal-newsletter-fehler-abmeldung").modal("show");
            } else {
                $("#modal-newsletter-fehler-abmeldung").modal("show");
            }
        });
    };

    var warnEmptyInput = function (element) {
        element.addClass("nl-empty-field");
        element.parents(".newsletter-form,.newsletter-unsub-form").siblings(".newsletter-fehler-format").fadeIn();
        element.parents(".newsletter-form").find(".newsletter-fehler-format").fadeIn();
    };

    var okInput = function (element) {
        element.removeClass("nl-empty-field");
        element.parents(".newsletter-form,.newsletter-unsub-form").siblings(".newsletter-fehler-format").fadeOut();
        element.parents(".newsletter-form").find(".newsletter-fehler-format").fadeOut();
    };

    $("body").on("click", "button.btn-nl", function (e) {
        e.stopPropagation();
        e.preventDefault();
        var inputField = $(this).parents(".newsletter-form, .newsletter-tooltip").find("input[name='n2gemail']");
        if (inputField.val() !== "" && validateEmail(inputField.val())) {
            $(".newsletter-fehler-format").hide();
            var transaction = inputField.data("transaction");
            if ($(this).attr("name") == "btn-nl-submit-gastro") {
                newRecipient(inputField.val(), "Gastro", $(this),transaction);
            }
            else if ($(this).attr("name") == "btn-nl-submit-gv") {
                newRecipient(inputField.val(), "GV",$(this),transaction);
            }
            else {
                console.log("Ungültige Gruppe");
            }

            if(typeof(e.target.nlsent) === "undefined"){
                $.ajax({
                    url:"nl_clickstats.htm",
                    data:{
                        "step":"complete"
                    }
                });
                e.target.nlsent = true;
            }
            $("input.newsletter-signup-trigger").prop('checked', true);
        } else {
            warnEmptyInput(inputField);
        }
    });

    $("body").on("keypress", "input[name=n2gemail],input[name=n2gunsub]", function (e) {
        if (e.which == 13) {
            var inputField = $(this);
            if (inputField.val() !== "" && validateEmail(inputField.val())) {
                okInput(inputField);
            } else {
                warnEmptyInput(inputField);
            }

        }
    });

    $("body").on("click", function () {
        $("input[name=n2gemail],input[name=n2gunsub]").each(function () {
            var inputField = $(this);
            if (inputField.val() !== "" && validateEmail(inputField.val())) {
                okInput(inputField);
            }
        });
    });

    $("body").on("click", "button.btn-nl-unsub", function (e) {
        e.preventDefault();

        var inputField = $(this).siblings("input[name='n2gunsub']");

        if (inputField.val() !== "" && validateEmail(inputField.val())) {
            $(".newsletter-fehler-format").hide();

            newsletterWaiting(true)

            $.ajax({
                url: nlBaseUrl + "newsletterasync.json",
                method: "post",
                data:{
                    action: "unsubscribe",
                    email: inputField.val()
                }
            }).done(function(res){
                newsletterWaiting(false);
                if(res["status"] === "success"){
                    $("#modal-newsletter-abmeldung-ok").modal("show");
                }
                else{
                    $("#modal-newsletter-fehler-abmeldung").modal("show");
                }
            });

        } else {
            warnEmptyInput(inputField);
        }
    });

    $("body").on("click", function () {
        $("input[name=n2gemail]").each(function () {
            var inputField = $(this);
            if (inputField.val() !== "" && validateEmail(inputField.val())) {
                okInput(inputField);
            }
        });

    });

    $("body").on("click", ".kreuz", function () {
        $(this).parents(".modal").modal("hide");
    });

    function nlInit(callback) {
        if ($("#modal-newsletter").length === 0 && (location.host === 'www.chefsculinar.de' || location.host === 'preview.chefsculinar.de')) {
            $.ajax({
                url: nlBaseUrl + "newsletter-modal.htm"
            }).done(function (html) {
                $("body").append(html);
                if (callback !== undefined) {
                    callback();
                }
            });
        } else {
            if (callback !== undefined) {
                callback();
            }
        }
    };

    $(".newsletter-popup").on("click", function (e) {
        e.preventDefault();
        $("#modal-newsletter").modal("show");
    });


    nlInit(function () {
        // Vertical centered modals
        var modalVerticalCenterClass = ".modal-newsletter";

        function centerModals(element) {
            var modals;
            if (element.length) {
                modals = element;
            } else {
                modals = $(modalVerticalCenterClass + ':visible');
            }
            modals.each(function (i) {
                var clone = $(this).clone().css('display', 'block').appendTo('body');
                var top = Math.round((clone.height() - clone.find('.modal-content').height()) / 2);
                top = top > 0 ? top : 0;
                clone.remove();
                $(this).find('.modal-content').css("margin-top", top);
            });
        }
        $(modalVerticalCenterClass).on('show.bs.modal', function (e) {
            centerModals($(this));
        });
        $(window).on('resize', centerModals);
    });

//Popup f�r Formulare

    $("body").on("click","label[for='newsletter-signup']",function(e){
        e.preventDefault();
    });
    $("body").on("click",".newsletter-signup-trigger",function(e){
        e.preventDefault();
        $(this).siblings(".newsletter-tooltip").toggleClass("active");
        $(this).siblings(".newsletter-tooltip").find(".nl-empty-field").removeClass("nl-empty-field");
        $(this).siblings(".newsletter-tooltip").find(".newsletter-fehler-format").hide();

    });
    $("body").on("click",".newsletter-tooltip .kreuz", function(e){
        e.preventDefault();
        $(this).parents(".newsletter-tooltip").removeClass("active");
        $(this).siblings(".newsletter-tooltip").find(".nl-empty-field").removeClass("nl-empty-field");
        $(this).siblings(".newsletter-tooltip").find(".newsletter-fehler-format").hide();
    });
    $("body").on("click",".newsletter-signup-trigger",function(){
        if(typeof(clicked_tooltip_nl) !== "undefined"){
            return;
        }
        clicked_tooltip_nl = true;

        $.ajax({
            url:"nl_clickstats.htm",
            data:{
                "step":"init"
            }
        });

    });
}

